
const RectcardComponent = ({ data }) => {
  const GetMoreText = itemdata => {
    try {
      if (
        itemdata?.offerdiscountprice != null &&
        itemdata?.currency != null &&
        itemdata?.offerdiscountprice != ''
      ) {
        return itemdata.currency + ' ' + itemdata.offerdiscountprice;
      } else if (itemdata.currency != null && itemdata.offerbaseprice != null) {
        return itemdata.currency + ' ' + itemdata.offerbaseprice;
      } else {
        return itemdata?.actiontext;
      }

    } catch (e) { }

    return '';

  };
  return (
    <>
      <div className="card_style_2 height_100">
        <div className="card_img">
          {data?.fifa && <div className="offer_placeholder end-0 top-0">
            <img src={process.env.PUBLIC_URL + '/assets/images/offer-icon.png'} alt="" title="" />
          </div>}
          <img src={data?.imageurl !== undefined ? data?.imageurl : (data?.imagepath !== undefined ? data?.imagepath : process.env.PUBLIC_URL + '/assets/images/s-internet.svg')} alt="" title="" />
        </div>
        <div className="card_info">
          <div className="card_info_grp">
            <h4>{data.title}</h4>
            <p>{data.description}</p>
          </div>
          <div className="card_link flex_grp_align_ce;nter">
            <div className="amount_stripe me-2">
              {data?.offerdiscountprice !== "" && `KD${data?.offerdiscountprice}`}
            </div>
            <div className="hyperlink">
              {GetMoreText(data)}
              {/* /<span className="text-lowercase">month</span> */}
              <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default RectcardComponent;
